function createContractState() {
  return {
    current: {
      id: null,
      extensions: [],
    },
    policyContext: null,
    referenceSubscription: null,
    pendingAmendment: null,
    amendmentModification: [],
    isCreatingAmendment: false,
    isApplyingAmendment: false,
    amendmentApplyError: '',
    amendmentFieldErrors: {},
  };
}

export {
  createContractState,
};
